<div class="modal is-active" *ngIf="isOpen">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 380px; overflow: visible">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="SELECT_PROPERTY_TYPE"
      >
        {{ 'SELECT_PROPERTY_TYPE' | translate }}
      </span>
      <button
        class="delete"
        (click)="onClose.emit()"
        aria-label="close"
      ></button>
    </div>
    <form class="modal-card-body p-5" style="overflow: visible">
      <div class="field">
        <label class="label" translationEditableDirective="EVALUATION_FORM">{{
          'EVALUATION_FORM' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="forms"
            [multiple]="false"
            [closeOnSelect]="true"
            bindLabel="name"
            (change)="selectedForm = $event; selectedFormId = $event?.id"
            bindValue="id"
            [ngModel]="selectedFormId"
          >
          </ng-select>
        </div>
      </div>
      <div class="field">
        <label class="label" translationEditableDirective="PROPERTY_TYPE">{{
          'PROPERTY_TYPE' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="propertyTypes"
            [multiple]="false"
            [closeOnSelect]="true"
            bindLabel="propertyType"
            bindValue="propertyType"
            (change)="selectedPropertyType = $event?.propertyType"
          >
          </ng-select>
        </div>
      </div>
    </form>
    <footer class="modal-card-foot">
      <button
        class="button is-success"
        (click)="
          onSave.emit(selectedPropertyType);
          onClose.emit();
          selectedFormId = activeFormId;
          selectedPropertyType = null
        "
        translationEditableDirective="SET"
        [disabled]="!selectedPropertyType"
        type="button"
      >
        {{ 'SET' | translate }}
      </button>
      <button
        class="button"
        type="button"
        (click)="onClose.emit()"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </button>
    </footer>
  </div>
</div>
